import { render, staticRenderFns } from "./DefectiveDetail.vue?vue&type=template&id=12e9cdeb&scoped=true"
import script from "./DefectiveDetail.vue?vue&type=script&lang=js"
export * from "./DefectiveDetail.vue?vue&type=script&lang=js"
import style0 from "./DefectiveDetail.vue?vue&type=style&index=0&id=12e9cdeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e9cdeb",
  null
  
)

export default component.exports